import { render } from "./RiskToolbar.vue?vue&type=template&id=61bcfbba&scoped=true"
import script from "./RiskToolbar.vue?vue&type=script&lang=js"
export * from "./RiskToolbar.vue?vue&type=script&lang=js"

import "./RiskToolbar.vue?vue&type=style&index=0&id=61bcfbba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bcfbba"]])

export default __exports__